import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $premiumLevel, $userBalance, $userLanguage, PremiumLevel } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { YourKeys } from '@/features/yourKeys'
import { PlatinumOffer } from '@/features/platinumOffer'
import { useMemo } from 'react'

export const ShopSales = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userSubscriptionLevel = useUnit($premiumLevel)
  const balance = useUnit($userBalance)
  const shouldShowSubscriptionBanner = useMemo<boolean>(() => {
    if (userSubscriptionLevel == PremiumLevel.UNSUBSCRIBED) {
      if (balance >= 500000) {
        return true
      }
    }
    return false
  }, [userSubscriptionLevel, balance])
  const texts = lang[userLang].pages.shop
  return (
    <div className={classes.root}>
      <span className={classes.heading}>{texts.shopHeading}</span>
      <YourKeys />
      <br />
      <div className={classes.offersContainer}>
        <span className={classes.subHeading}>{texts.specialOffers}</span>
        {shouldShowSubscriptionBanner ? <PlatinumOffer /> : null}
        {!shouldShowSubscriptionBanner && <p className={classes.nothingHere}>{texts.nothing}</p>}
      </div>
    </div>
  )
}
